import styled from "styled-components";
import logo from "../../../assets/images/login/xnuup_main_logo_black.png";

export const Form = styled.form`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	padding: 0 3.6rem;
	gap: 10px;

	@media (max-width: 426px) {
		padding: 0 1.6rem;
	}
`;

export const Logo = styled.div`
	background-image: url(${logo});
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	height: 60px;
	margin-top: 20px;
	margin-bottom: 20px;
	width: 100%;

	@media (max-width: 426px) {
		height: 40px;
		margin-bottom: 1px;
		margin-top: 3px;
	}
`;
